export const iconFontAwesomeCampingBottleWater = (
	<i className="fa-solid fa-bottle-water"></i>
);
